module.exports = __webpack_public_path__ + "static/media/banner_header_buenfin.5725de8d.svg";